import { dateFormat } from "../../config";
import { getFormattedDateWithTodayYesterday } from "../../helper/common";
import store from "../../store";
import { saveClickHistory } from "./recentHistory.service";

export const saveEntityRecentHistory = (entityId, entityName) => {
    let state = store.getState();

    let payload = {
        userId: state.auth.user.id,
        entityId: entityId,
        entityName: entityName
    }
    store.dispatch(saveClickHistory(payload))
}

export const historyInitialGroup = [{
    field: "ViewedOn"
}]

/**
 * Returns the formatted date for recent history (in user timezone).
 * If the date is today → "Today", if yesterday → "Yesterday", else full date e.g. "18 Feb 26".
 * @param {string} dateString - ISO or date string from API
 * @returns {string} date label
 * @author Sejal
 */
export const getRecentHistoryFormattedDate = (dateString) => {
    return getFormattedDateWithTodayYesterday(dateString, dateFormat.COMMON_DATE_FORMAT);
};

/**
 * Used to filter recent history tasks for the viewed on date
 * @param {*} tasks
 * @author Prachi Jain
 */
export const filterRecentTasks = (tasks) => {
    const filteredTasks = []
    tasks?.map((task) => {
        task.ViewedOn = task.CreatedOn ? getRecentHistoryFormattedDate(task.CreatedOn) : ""
        filteredTasks.push(task)
    })
    return filteredTasks
}

